import React from 'react';
import { BiSolidLockOpen as LockIcon } from 'react-icons/bi';
import { BsGearWideConnected as GearIcon, BsLightningChargeFill as LightningIcon } from 'react-icons/bs';
import { FaClock as ClockIcon, FaWrench as WrenchIcon } from 'react-icons/fa';
import { MdSensorDoor as DoorIcon } from 'react-icons/md';
import { TiWeatherDownpour as RainIcon } from 'react-icons/ti';

import { Colors } from '../../utils/Colors';

import brochure from '../../assets/pdfDocuments/FR/ultra/Brochure TECH-ROLL ULTRA.pdf';
import specificationCD from '../../assets/pdfDocuments/FR/ultra/Specifications TECH-ROLL ULTRA CD - INDOTECH.pdf';
import specificationDD from '../../assets/pdfDocuments/FR/ultra/Specifications TECH-ROLL ULTRA DD - INDOTECH.pdf';
import bottomBarImg from '../../assets/pictures/components/bottomBar.svg';
import brakesImg from '../../assets/pictures/components/brakes.svg';
import curtainImg from '../../assets/pictures/components/curtain.svg';
import endlocksImg from '../../assets/pictures/components/endlocks.svg';
import guidesImg from '../../assets/pictures/components/guides.svg';
import operatorImg from '../../assets/pictures/components/operator.svg';
import springsImg from '../../assets/pictures/components/springs.svg';
import windbarsImg from '../../assets/pictures/components/windbars.svg';

export const ultraPdfs = [
    { pdfTitle: 'products.ultra.pdfs.brochure', pdfLink: { fr: brochure, en: brochure } },
    { pdfTitle: 'products.ultra.pdfs.specificationCD', pdfLink: { fr: specificationCD, en: specificationCD } },
    { pdfTitle: 'products.ultra.pdfs.specificationDD', pdfLink: { fr: specificationDD, en: specificationDD } },
];

export const ultraInfoKeys = [
    'products.ultra.infos.motor',
    'products.ultra.infos.cce',
    'products.ultra.infos.curtain',
    'products.ultra.infos.guides',
    'products.ultra.infos.springs',
    'products.ultra.infos.springless',
    'products.ultra.infos.selfRepair',
    'products.ultra.infos.bar',
    'products.ultra.infos.safety',
];

export const ultraBenefits = [
    {
        benefitKey: 'products.ultra.benefits.waterproof',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <RainIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.speed',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LightningIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.costNoProduction',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <GearIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.costRepair',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <WrenchIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.maintenance',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <ClockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.impact',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <DoorIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.ultra.benefits.security',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
];

export const ultraSpecificationKeys = [
    {
        label: 'specificationsLabel.cycles',
        value: 'products.ultra.specificationsValues.cycles',
    },
    {
        label: 'specificationsLabel.drive_system',
        value: [
            {
                label: 'products.ultra.specificationsValues.drive_system.chain_driven_operator',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.direct_drive_operator',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.integrated_brake_system',
                value: 'specificationSecondValues.electromagnetic',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.one_phase_208_to_240_volts',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.three_phase_208_to_575_volts',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.chain_hoist_for_manual_operation',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.speed_variator',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.ultra.specificationsValues.drive_system.control_panel',
                value: 'specificationSecondValues.standard_with_vfd_plc',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain',
        value: [
            {
                label: 'products.ultra.specificationsValues.curtain.sbr',
                value: 'specificationSecondValues.standard_black',
            },
            {
                label: 'products.ultra.specificationsValues.curtain.thickness',
                value: 'specificationSecondValues.blue_curtain_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain_idler',
        value: 'products.ultra.specificationsValues.curtain_idler',
    },
    {
        label: 'specificationsLabel.temperature',
        value: 'products.ultra.specificationsValues.temperature',
    },
    {
        label: 'specificationsLabel.endlock_system',
        value: 'products.ultra.specificationsValues.endlock_system',
    },
    {
        label: 'specificationsLabel.bottom_bar',
        value: 'products.ultra.specificationsValues.bottom_bar',
    },
    {
        label: 'specificationsLabel.guide',
        value: 'products.ultra.specificationsValues.guide',
    },
    {
        label: 'specificationsLabel.inertia_brake',
        value: 'products.ultra.specificationsValues.inertia_brake',
    },
    {
        label: 'specificationsLabel.frame_color',
        value: [
            {
                label: 'products.ultra.specificationsValues.frame_color.standard_yellow',
                value: 'specificationSecondValues.other_colors_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.safety',
        value: 'products.ultra.specificationsValues.safety',
    },
    {
        label: 'specificationsLabel.mounting',
        value: [
            {
                label: 'products.ultra.specificationsValues.mounting.concrete',
                value: 'products.ultra.specificationsValues.mounting.steel',
            },
        ],
    },
    {
        label: 'specificationsLabel.balance_system',
        value: [
            {
                label: 'products.ultra.specificationsValues.balance_system.springs',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.balance_system.counter_weight',
                value: 'specificationSecondValues.not_required',
            },
        ],
    },
    {
        label: 'specificationsLabel.wind_bar',
        value: [
            {
                label: 'products.ultra.specificationsValues.wind_bar.one',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.wind_bar.two',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.wind_bar.external',
                value: 'specificationSecondValues.available_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.options',
        value: [
            {
                label: 'products.ultra.specificationsValues.options.windows',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.ultra.specificationsValues.options.pneumatic_sensor',
                value: 'specificationSecondValues.reversing_edges',
            },
            {
                label: 'products.ultra.specificationsValues.options.reflective_stripes',
                value: 'specificationSecondValues.yellow_and_gray',
            },
            {
                label: 'products.ultra.specificationsValues.options.photocells',
                value: 'specificationSecondValues.available',
            },
        ],
    },
    {
        label: 'specificationsLabel.other_electric',
        value: 'products.ultra.specificationsValues.other_electric',
    },
    {
        label: 'specificationsLabel.wind_res',
        value: 'products.ultra.specificationsValues.wind_res',
    },
];

export const ultraComponents = [
    {
        id: 'curtain',
        number: 1,
        title: 'products.ultra.components.curtain.title',
        description: 'products.ultra.components.curtain.description',
        img: curtainImg,
    },
    {
        id: 'endLocks',
        number: 2,
        title: 'products.ultra.components.endLocks.title',
        description: 'products.ultra.components.endLocks.description',
        img: endlocksImg,
    },
    {
        id: 'bottomBar',
        number: 3,
        title: 'products.ultra.components.bottomBar.title',
        description: 'products.ultra.components.bottomBar.description',
        img: bottomBarImg,
    },
    {
        id: 'guideRails',
        number: 4,
        title: 'products.ultra.components.guideRails.title',
        description: 'products.ultra.components.guideRails.description',
        img: guidesImg,
    },
    {
        id: 'windBars',
        number: 5,
        title: 'products.ultra.components.windBars.title',
        description: 'products.ultra.components.windBars.description',
        img: windbarsImg,
        isOptional: true,
    },
    {
        id: 'springs',
        number: 6,
        title: 'products.ultra.components.springs.title',
        description: 'products.ultra.components.springs.description',
        img: springsImg,
        isOptional: true,
    },
    {
        id: 'operators',
        number: 7,
        title: 'products.ultra.components.operators.title',
        description: 'products.ultra.components.operators.description',
        img: operatorImg,
    },
    {
        id: 'brakes',
        number: 8,
        title: 'products.ultra.components.brakes.title',
        description: 'products.ultra.components.brakes.description',
        img: brakesImg,
    },
];
